import React from 'react';
import { Box, Heading, Flex } from '@chakra-ui/layout';
import { Icon } from 'components';
import { colors } from 'theme/colors';

interface IProps {
  email?: string;
  name: string;
  onRemove: (a: any) => any;
  enabled?: boolean;
}

const ParticipantCard: React.FC<IProps> = ({ name, email, onRemove }) => {
  return (
    <Flex
      flexDirection="row"
      alignItems="center"
      pl="16px"
      pr="22px"
      width="100%"
      mt="6px"
      minHeight="44px"
      py="8px"
      bg={'#fff'}
      borderRadius={4}
      border="1px solid #BFBFBF"
    >
      <Flex width="50%">
        <Heading fontWeight="bold" as="span" fontSize="14px">
          {email}
        </Heading>
      </Flex>
      <Flex width="30%">
        <Heading as="span" fontWeight="bold" fontSize="14px" color={colors.brand.gray400}>
          {name}
        </Heading>
      </Flex>
      <Box
        ml="auto"
        transition="all ease-in 200ms"
        _active={{
          opacity: 0.5,
        }}
        _hover={{
          opacity: 0.7,
        }}
        as="button"
        type="button"
        onClick={onRemove}
      >
        <Icon name="trashed" size={1} color={'red200'} />
      </Box>
    </Flex>
  );
};

export default ParticipantCard;
